module.exports = __webpack_public_path__ + "static/media/illo-painter.1a3cc1dd.jpg";